import React from "react";
import InstagramFeed from "../components/InstagramFeed";
import { Link } from "react-router-dom";


const postsImmobilier = [
  {
    id: 1,
    title: 'Quels sont les frais à prévoir lors de la vente d’un bien immobilier ?',
    href: 'https://clotere.framer.website/blog/quels-sont-les-frais-%C3%A0-pr%C3%A9voir-lors-de-la-vente-d-un-bien-immobilier',
    description: "Allant jusqu'à 6% du prix d'achat de votre bien, les frais de notaire représente un poste de dépense important. Bien anticipé ce coût est important, on vous explique tout sur ces frais de notaire.",
    imageUrl:
      'https://framerusercontent.com/images/oHanIMlzl6HOQ0CmHjJrGGa0Wo.png',
    category: { title: 'Immobilier', href: '#' },
  },
  {
    id: 2,
    title: 'Les clauses suspensives, finalement qu\'est-ce que c\'est ?',
    href: 'https://clotere.framer.website/blog/les-clauses-suspensives-qu-est-ce-que-c-est',
    description: "Si vous achetez un bien immobilier vous entendrez forcément parlé des clauses suspensives 🤔 ! Ne vous inquiétez pas c'est très simple, on vous explique tout dans cet article.",
    imageUrl:
      'https://framerusercontent.com/images/7qUTqENEJz4uogCoIgtjNUWQA.webp',
    category: { title: 'Immobilier', href: '#' },
  },
  {
    id: 3,
    title: 'Le rôle du notaire dans la vente d’un bien immobilier',
    href: 'https://clotere.framer.website/blog/le-r%C3%B4le-du-notaire-dans-la-vente-d-un-bien-immobilier',
    description: "Acquérir un bien immobilier requiert toujours l’intervention d’un notaire, au moins pour réaliser l’acte de vente. Comment faire le choix d’un notaire pour un achat immobilier ? Découvrez nos conseils.",
    imageUrl:
      'https://framerusercontent.com/images/iSpNwoZYeVubhimwPBiD3iJpg8.webp',
    category: { title: 'Immobilier', href: '#' },
  },
]
const postsMariage = [
  {
    id: 1,
    title: 'Les étapes pour établir un contrat de mariage avec un notaire',
    href: 'http://clotere.fr/contrat-mariage/notaire/etapes-contrat-de-mariage',
    description: "Allant jusqu'à 6% du prix d'achat de votre bien, les frais de notaire représente un poste de dépense important. Bien anticipé ce coût est important, on vous explique tout sur ces frais de notaire.",
    imageUrl:
      'https://framerusercontent.com/images/oHanIMlzl6HOQ0CmHjJrGGa0Wo.png',
    category: { title: 'Contrat de mariage', href: '#' },
  },
  {
    id: 2,
    title: 'Pourquoi faire un contrat de mariage chez le notaire ?',
    href: 'https://clotere.fr/contrat-mariage/notaire/pourquoi-faire-un-contrat-de-mariage',
    description: "Vous allez vous marier et vous vous demandez si un contrat de mariage est vraiment nécessaire ? Ce document, souvent perçu comme secondaire, est pourtant essentiel pour protéger vos intérêts et ceux de votre partenaire.",
    imageUrl:
      'https://framerusercontent.com/images/7qUTqENEJz4uogCoIgtjNUWQA.webp',
    category: { title: 'Contrat de mariage', href: '#' },
  },
  {
    id: 3,
    title: 'Quel régime matrimonial choisir pour votre mariage ?',
    href: 'https://clotere.fr/contrat-mariage/notaire/regimes-matrimoniaux',
    description: "Un contrat de mariage est un acte juridique rédigé par un notaire avant ou après le mariage, permettant aux époux de choisir un régime matrimonial différent de celui imposé par défaut par la loi.",
    imageUrl:
      'https://framerusercontent.com/images/iSpNwoZYeVubhimwPBiD3iJpg8.webp',
    category: { title: 'Régime matrimonial', href: '#' },
  },
]
const postsPacs = [
  {
    id: 1,
    title: "Les avantages juridiques de votre convention de pacs chez le notaire",
    date: "23 mars 2025",
    href: "https://clotere.fr/pacs/notaire/avantages-juridiques-de-votre-convention-de-pacs-chez-le-notaire",
    imageUrl: "https://images.unsplash.com/photo-1426543881949-cbd9a76740a4?q=80&w=1587&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Découvrez pourquoi établir votre convention de PACS chez un notaire est un choix sécurisant. Conseils personnalisés, protection juridique renforcée, gestion patrimoniale sur-mesure : explorez tous les avantages pour organiser votre vie commune en toute sérénité.",
    category: { title: 'Pacs notaire', href: '#' }
  },
  {
    id: 2,
    title: "Tout savoir sur la convention de PACS chez le notaire",
    date: "3 avril 2025",
    href: "https://clotere.fr/pacs/notaire/tout-savoir-sur-la-convention-de-pacs-chez-le-notaire",
    imageUrl: "https://images.unsplash.com/photo-1468779036391-52341f60b55d?q=80&w=1668&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Préparez sereinement votre PACS chez le notaire grâce à notre liste complète des documents indispensables. Acte de naissance, pièce d’identité, convention de PACS : retrouvez tous les justificatifs nécessaires pour un enregistrement rapide et sécurisé.",
    category: { title: 'Pacs notaire', href: '#' }
  },
  {
    id: 3,
    title: "Les étapes de votre convention de PACS chez le notaire.",
    date: "12 avril 2025",
    href: "https://clotere.fr/pacs/notaire/etapes-pacs-notaire",
    imageUrl: "https://images.unsplash.com/photo-1613038490055-c811458f113f?q=80&w=1548&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Découvrez toutes les étapes clés pour établir votre convention de PACS chez le notaire : préparation des documents, rédaction, signature et enregistrement. Un guide complet pour organiser votre union en toute sécurité.",
    category: { title: 'Pacs notaire', href: '#' }
  },
  {
    id: 4,
    title: "Que peut-on prévoir dans une convention de PACS notariée ?",
    date: "12 avril 2025",
    href: "https://clotere.fr/pacs/notaire/details-clauses-convention-de-pacs-chez-le-notaire",
    imageUrl: "https://images.unsplash.com/photo-1573497620053-ea5300f94f21?q=80&w=1740&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    description: "Explorez en détail les clauses essentielles d’une convention de PACS chez le notaire : séparation de biens, organisation des charges, dispositions en cas de rupture ou de décès. Tout pour personnaliser votre PACS en fonction de votre situation.",
    category: { title: 'Pacs notaire', href: '#' }
  }
]

function ArticlesSimilaires(args) {

  return (
    <>
      <div className="container">
        <div className="bg-white p-4 ">
          <div className="flex -space-x-1 overflow-hidden justify-center">
            <img
              alt="trouver votre notaire"
              src="https://images.unsplash.com/photo-1491528323818-fdd1faba62cc?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              className="inline-block size-10 rounded-full ring-2 ring-white"
            />
            <img
              alt="comprendre votre notaire"
              src="https://images.unsplash.com/photo-1550525811-e5869dd03032?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              className="inline-block size-10 rounded-full ring-2 ring-white"
            />
            <img
              alt="question à votre notaire"
              src="https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2.25&w=256&h=256&q=80"
              className="inline-block size-10 rounded-full ring-2 ring-white"
            />
            <img
              alt="simplifiez votre passage chez le notaire"
              src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
              className="inline-block size-10 rounded-full ring-2 ring-white"
            />
          </div>
          <h2 className=" mt-6 !text-xl font-bold tracking-tight text-gray-900">Mieux comprendre vos démarches chez le notaire</h2>



          {/** article de blog */}
          <div>
            {postsImmobilier.map((post) => (
              <article key={post.id} className="relative isolate flex flex-col gap-4  mb-8">
                <div className="relative w-full">
                  <img
                    alt=""
                    src={post.imageUrl}
                    className="inset-0 size-full rounded-2xl bg-gray-50 object-cover"
                  />
                  <div className="absolute inset-0 rounded-2xl ring-1 ring-gray-900/10 ring-inset" />
                </div>
                <div>
                  <div className="flex items-center gap-x-4 text-xs">
                    <p className="relative z-10 rounded-full bg-indigo-50 px-3 py-1.5 font-medium text-indigo-600 hover:bg-gray-100 no-underline">
                      {post.category.title}
                    </p>
                  </div>
                  <div className="group relative max-w-xl">
                    <h3 className="!text-lg font-semibold text-gray-900 group-hover:text-gray-600">
                      <a href={post.href} className="text-black no-underline">
                        <span className="absolute inset-0" />
                        {post.title}
                      </a>
                    </h3>
                    <p className="text-sm/6 text-gray-600">{post.description}</p>
                  </div>
                </div>
              </article>
            ))}

            <div className="flex justify-center">
              <a href="https://clotere.fr/blog" target="blank" className="btn-main no-underline w-full">Lire le blog</a>
            </div>
          </div>
        </div>
        {/** demarches populaires */}
        <div className="bg-white p-4 mt-8">
            <p className="mt-6 !text-xl font-bold tracking-tight text-gray-900">
              Débutez votre dossier en quelques clics
            </p>
            <div className="flex gap-4 flex-wrap justify-between z-50  mx-auto">
              <Link to="/notaire-contrat-mariage" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Contrat de mariage</Link>
              <Link to="/notaire-pma" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Démarches notariales PMA</Link>
              <Link to="/notaire-pma" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Reconnaissance conjointe anticipée</Link>
              <Link to="/notaire-acheteur" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Achat immobilier</Link>
              <Link to="/notaire-vendeur" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Vente immobilière</Link>
              <Link to="/notaire-pacs" className="px-4 py-2 rounded-full bg-indigo-200 no-underline text-indigo-800 font-semibold">Convention de PACS notaire</Link>
            </div>
        </div>
        {/** instagram */}
        <div className="bg-white p-4 mt-8">
          <div className="text-center justify-center">
            <p className="mt-2 text-lg font-semibold leading-8 text-gray-600 text-center mb-12">
              Des vidéos pour vous guider
            </p>
            <InstagramFeed url="https://www.instagram.com/reel/DH-14DKtWJe/" />

            <div className="flex justify-center">
              <a href="https://www.instagram.com/clotere_notaire/" target="blank" className="btn-main no-underline w-full">Suivez-nous sur instagram</a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ArticlesSimilaires;